// extracted by mini-css-extract-plugin
module.exports = {"base":"AvatarCard_base__2u8D_"};